import React from 'react';
import { css } from '@emotion/core';
import Link from '../../../shared/Link/Link';

import './ImageBanner.scss';

import DiscountLineBanner from './DiscountLineBanner';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';

const ImageBanner = ({ imageBannerVersion, advImages }) => {
  const imageBannerStyle = css`
    &.version-1 .image-banner,
    &.version-3 .image-banner {
      height: 212px;
      @media screen and (max-width: 992px) {
        height: 120px;
      }

      .container {
        height: 100%;
        border-radius: 6px;
        max-width: 94%;
        img {
          height: 100%;
          width: 100%;
          object-fit: cover;
          border-radius: 6px;
        }
      }
    }

    &.version-1 {
      max-width: 94%;
      margin: 0 auto;
    }

    &.version-2 .image-banner {
      // height: 225px;
      .container {
        height: 100%;
        @media screen and (max-width: 768px) {
          height: 100px;
        }

        border-radius: 6px;
        img {
          height: 100%;
          width: 100%;
          object-fit: cover;
          border-radius: 6px;
        }
      }
    }
  `;

  return (
    <div
      className={`image-banner-wrapper version-${imageBannerVersion}`}
      css={imageBannerStyle}
    >
      <div className="image-banner">
        <div className="container">
          {advImages.adv1Link ? (
            advImages.adv1Link.includes('https') ? (
              <a href={advImages.adv1Link} rel="noreferrer" target="_blank">
                <ImageDispatcher
                  src={advImages.adv1ImageUrl}
                  alt={`Immagine relativa alla pagina ${advImages.adv1Link}`}
                  style={{
                    minHeight: '100%',
                    maxHeight: '100%',
                    borderRadius: 12,
                  }}
                />
              </a>
            ) : (
              <Link to={advImages.adv1Link}>
                <ImageDispatcher
                  src={advImages.adv1ImageUrl}
                  alt={`Immagine relativa alla pagina ${(
                    advImages.adv1Link || ''
                  ).replace(/\//g, '')}`}
                  style={{
                    minHeight: '100%',
                    maxHeight: '100%',
                    borderRadius: 12,
                  }}
                />
              </Link>
            )
          ) : (
            <ImageDispatcher
              src={advImages.adv1ImageUrl}
              alt="Immagine pubblicitaria banner"
              style={{
                minHeight: '100%',
                maxHeight: '100%',
                borderRadius: 12,
              }}
            />
          )}
        </div>
      </div>

      {imageBannerVersion === 1 ? (
        <DiscountLineBanner
          imageBannerVersion={imageBannerVersion}
          advImages={advImages}
        />
      ) : null}
    </div>
  );
};
export default ImageBanner;
// imageBannerVersion 1: basic version, the ImageBanner component renders both a container and the DiscountLineBanner.
// imageBannerVersion 2: the DiscountLineBanner is not rendered inside ImageBanner.js since it needs to be rendered within Footer.js in case of FooterVersion === 2;
